import { APIFailureContext } from "components/app/APIFailureContext";
import { setDialog } from "components/features/Corp/CorpUser.Slice";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { FEEDBACK_TIMER, messageTypes, messages } from "utils/CommonConstants";
import { editList } from "utils/CommonFunctions";
import { apiFailureMessageTypes, responseTypes } from "utils/Types";
import Feedback from "../Feedback";

export default function Snackbar() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const translate = useTranslate();

  const [showAPIError, setShowAPIError] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const feedbackDetail: any = useAppSelector((state) => state.snackbarDetails.feedbackDetails);
  const listCreatedSuccess = useAppSelector((state) => state.CorpDashboard.listCreatedSuccess);
  const listCategory = useAppSelector((state) => state.CorpDashboard.myListsSelected.listCategory);
  const selectedList = useAppSelector((state) => state.CorpDashboard.myListsSelected.selectedList);
  const isViewMode = useAppSelector((state) => state.myPlanDetails.isViewMode);

  const context = useContext(APIFailureContext);

  useEffect(() => {
    if (context?.state?.status) {
      setShowAPIError(true);
    }
  }, [context]);

  useEffect(() => {
    if (location?.state?.message) setSnackbarMessage(location?.state?.message);
  }, [location]);

  const getMessage = (messageType: string) => {
    switch (messageType) {
      case messageTypes.singleOwner:
      case messageTypes.multipleOwners: {
        return `Contact ${
          feedbackDetail?.displayName ? feedbackDetail?.displayName : ""
        }, the Plan Member who is the Owner to request changes.`;
      }
      default: {
        return `Modifications can't be made. This is preconfigured to ensure a successful and on-time implementation.`;
      }
    }
  };

  const clickHandler = () => {
    const type = listCategory === "consultant" ? "sc" : "static";
    if (listCategory === "consultant" || listCategory === "static") {
      editList(selectedList, type);
    } else {
      dispatch(setDialog({ dialogName: "renameList", isOpen: true, data: selectedList }));
    }
  };

  const onRefreshClickHandler = () => {
    window.location.reload();
  };

  return (
    <>
      <Feedback
        form=""
        actionStatus={{
          shouldShow: location?.state?.hasNoAccess,
          variant: location?.state?.variant ? location?.state?.variant : "error"
        }}
        message={location?.state?.message ? location?.state?.message : snackbarMessage}
        onCloseChange={() =>
          navigate(`${location.pathname}${location?.search}`, {
            state: {},
            replace: true
          })
        }
      />

      <Feedback
        form=""
        actionStatus={{
          shouldShow: showAPIError,
          variant: "error"
        }}
        message={
          context?.state?.status < responseTypes.internal_error
            ? context?.state?.data?.errors?.[0]?.detail || apiFailureMessageTypes[400]
            : apiFailureMessageTypes[500]
        }
        linkLabel={`${context?.state?.status < responseTypes.internal_error ? "" : "refresh"} `}
        clickHandler={onRefreshClickHandler}
        onCloseChange={() => setShowAPIError(false)}
      />
      <Feedback form="deletePlan" message="This has been deleted." />
      <Feedback form="removeInvitee" message={translate("myPlan.memberRemoval")} />
      <Feedback form="deleteList" message={messages.listDeleteSuccess} />
      <Feedback form="createFilterByTypes" />
      <Feedback
        form="duplicateFilter"
        message={"List was successfully duplicated!"}
        linkLabel="Rename List"
        clickHandler={clickHandler}
      />
      <Feedback
        form=""
        actionStatus={{ shouldShow: listCreatedSuccess.isCreated, variant: "success", timer: FEEDBACK_TIMER }}
        message={listCreatedSuccess.message}
      />
      <Feedback
        form=""
        actionStatus={{
          shouldShow: feedbackDetail?.shouldShow,
          variant: feedbackDetail?.variant ? feedbackDetail?.variant : "error",
          setState: feedbackDetail?.setState,
          timer: FEEDBACK_TIMER
        }}
        message={feedbackDetail?.message ? feedbackDetail?.message : getMessage(feedbackDetail?.messageType)}
      />

      <Feedback form="addToMyPlans" message={messages.planAdded} />

      {!isViewMode && (
        <>
          <Feedback form="addInvitee" message={messages.memberInvited} />
        </>
      )}
    </>
  );
}
